/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import React, { useState } from 'react';
import Select from '@mui/material/Select';
import i18next from 'i18next';
import MenuItem from '@mui/material/MenuItem';
import { Earth } from 'lucide-react';
import Box from '@mui/material/Box';

import { getStoredLanguage, storeLanguage } from '../localStorageHelper';

export const LanguageSelector = () => {
  const [language, setLanguage] = useState(getStoredLanguage());

  const handleLanguageChange = (event: any) => {
    const newLanguage = event.target.value;
    setLanguage(newLanguage);
    storeLanguage(newLanguage);
    i18next.changeLanguage(newLanguage);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Earth size={20} color="white" style={{ marginRight: 2 }} />
      <Select
        value={language}
        onChange={handleLanguageChange}
        sx={{
          color: 'white',
          '& .MuiSelect-icon': { color: 'white' },
          '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
          marginRight: 2,
          '&:before': { borderBottom: 'none' },
          '&:after': { borderBottom: 'none' },
          '& [role=combobox]': {
            paddingTop: 0,
            paddingBottom: 0,
          },
        }}
      >
        <MenuItem value="en">English</MenuItem>
        <MenuItem value="zh">简体中文</MenuItem>
      </Select>
    </Box>
  );
};
